import { PricingRangeRecord } from 'apps/website/types/dato';
import { orderPricingRange } from '../orderPricingRange';

export const mapperPricingRanges = (pricingRanges: PricingRangeRecord[]) => {
  const newPricingRanges = pricingRanges.map((price) => ({
    base: !price.onDemand && price.base,
    labels: price.labelsPricingRange,
    price: !price.onDemand && price.price,
    obFees: !price.onDemand && price.obFees,
    from: price.from,
    to: price.to,
    onDemand: price.onDemand,
    discountPrices: price.discountPrices
      ? {
          base: price.discountPrices.base,
          price: price.discountPrices.price,
          obFees: price.discountPrices.obFees,
        }
      : undefined,
  }));

  return orderPricingRange(newPricingRanges);
};
